import { Box, Text } from '@air/zephyr';

import { AgencyContainer } from '~/old-marketing/components/agency/AgencyContainer';
import { AgencySectionTitle } from '~/old-marketing/components/agency/AgencySectionTitle';
import { CuratedAgenciesList } from '~/old-marketing/components/agency/CuratedAgenciesList';
import { LimitedAgencyData } from '~/old-marketing/components/types/custom-types';

export interface CuratedAgenciesSectionProps {
  agencies?: LimitedAgencyData[];
}

export const CuratedAgenciesSection = ({ agencies }: CuratedAgenciesSectionProps) => {
  return (
    <Box as="section" tx={{ py: 120 }}>
      <AgencyContainer>
        <Box tx={{ maxWidth: 694, mx: 'auto', mb: 48, textAlign: ['left', 'center'] }}>
          <AgencySectionTitle>Agencies we love</AgencySectionTitle>

          <Text as="p" tx={{ mb: 40, color: 'pigeon700' }} variant="text-ui-18">
            Check out agencies we recommend to solve your brand&apos;s unique needs.
          </Text>
        </Box>
        <CuratedAgenciesList agencies={agencies} />
      </AgencyContainer>
    </Box>
  );
};
